// extracted by mini-css-extract-plugin
export default {"Pagination":"Pagination_Pagination__Pbdzp","page":"Pagination_page__SUeyo","active":"Pagination_active__97SL7","disabled":"Pagination_disabled__AkQbf"};